<template>
  <div class='container'>

    <div class='home-text' :class="{en: language=== 'EN'}">{{ language === 'TC' ? '請選擇語言' : 'Please select language' }}</div>


    <div class="select-box">
      <img v-if="language === 'TC'" src="../assets/image/cn_on.png" alt="">
      <img v-else src="../assets/image/cn_off.png" @click="switchLanguage('TC')" alt="">    
      <img v-if="language === 'TC'" src="../assets/image/en_off.png" @click="switchLanguage('EN')" alt="">
      <img v-else src="../assets/image/en_on.png" alt="">
      
    </div>

    <img v-if="language === 'TC'" @click="toLogin" class='bottom-btn btn' src="../assets/image/tc/btn_start.png" alt="">
    <img v-else @click="toLogin" class='bottom-btn btn' src="../assets/image/en/btn_continue.png" alt="">

  </div>
</template>

<script>
  import axios from 'axios'


  export default {
    data () {
      return {
        
      }
    },
    mounted(){
      let timestamp = this.getParameterByName('t')
      let shopId = this.getParameterByName('s')

      console.log(timestamp, shopId);
      if (shopId) {
        this.$store.commit('set_shop_id', shopId)
      }

      if (timestamp) {
        this.$store.commit('set_timestamp', timestamp)
      } else {
        this.getUserInfo()
      }
    },
    methods:{
      switchLanguage(lang) {
        this.$store.commit('set_language', lang)
        localStorage.setItem('language', lang)
      },

      getUserInfo() {
        var me = this
        
        console.log('getUserInfo', me.openid)
        if (!me.openid) {
          // LINE LIFF userId 尚未取得，略過查詢
          return
        }
        axios({
          method: 'get',
          url: me.baseUrl + '/scanner/users/' + me.openid,
        }).then(res => {
          if (res.status === 200 && res.data.data && res.data.data.length) { 
            me.$router.replace({ path: "/user_center" })
          }
        }).catch(e => {
          console.log('getUserInfo-e :>> ', e)
        })
      },


      toLogin() {
        this.$router.push({ path: "/login" })
        
      },

      getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
      }
      
    },

    computed: {
      language() {
        return this.$store.state.language
      },
      timestamp() {
        return this.$store.state.timestamp
      },
      openid() {
        return this.$store.state.openid
      },
      shopId() {
        return this.$store.state.shopId
      },
      baseUrl() {
        return this.$store.state.baseUrl
      },
    },
  }
</script>


<style lang="less" scoped>


  .home-text {
    position: absolute;
    top: 18vw;
    width: 100%;
    font-size: 5.8vw;
    font-weight: bold;
    text-align: center;
    font-family: 'fs-bold';
    &.en {
      font-family: 'en-bold';
    }
  }

  .select-box {
    position: absolute;
    top: 67vw;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 34vw;
      margin: 0 5vw;
    }
  }

  .bottom-btn {
    position: absolute;
    bottom: 8vw;
    left: 6.4vw;
    width: 87.2vw;
    
  }

</style>



// WEBPACK FOOTER //
// src/pages/home.vue